(ns frontend.view.settings2.fundraising-pipelines.db
  (:require [reagent.core :as r]
            [frontend.db :as app-db]))

(def state (r/cursor app-db/app-state [:views :settings :fundraising-opportunity-pipeline]))
